import { useRef, useEffect } from "react"
import cn from "clsx"
import styles from "./styles.module.scss"
import type { FC, HTMLAttributes } from "react"


interface SpacerProps
extends HTMLAttributes<HTMLDivElement> {}

export const Spacer: FC<SpacerProps> = ({ className, ...rest }) => {
  const spacerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const scrollHandler = () => {
      const { scrollTop, scrollHeight } = document.documentElement
      const { innerHeight } = window
      const scrollPercent = scrollTop / (scrollHeight - innerHeight)
      spacerRef.current.style.height = `${20 * scrollPercent}vh`
    }
    window.addEventListener('scroll', scrollHandler, { passive: true })
    return () => window.removeEventListener('scroll', scrollHandler)
  }, [])

  return <div {...rest} className={cn(styles.spacer, className)} ref={spacerRef} />
}
